import { ICONS } from "@/lib/icons";
import { Reveal, SectionHeading } from "./Reveal";

export default function Features({ content }) {
  const c = content?.features;
  const items = c?.items || [];
  return (
    <section id="features" className="bg-cream py-24 sm:py-28">
      <div className="mx-auto max-w-7xl px-5">
        <SectionHeading eyebrow={c?.eyebrow} title={c?.title} />
        <div className="mt-14 grid gap-5 md:grid-cols-3">
          {items.map((item, i) => {
            const Icon = ICONS[item.icon] || ICONS.star;
            const wide = i === 0;
            const full = i === items.length - 1 && items.length % 3 !== 0;
            return (
              <Reveal
                key={i}
                delay={0.06 * i}
                className={`${wide ? "md:col-span-2" : ""} ${full ? "md:col-span-3" : ""}`}
              >
                <article
                  data-testid={`feature-card-${i}`}
                  className={`group flex h-full gap-5 rounded-3xl border border-line bg-white p-7 transition-all duration-300 hover:-translate-y-1.5 hover:border-gold/50 hover:shadow-[0_30px_60px_-25px_rgba(212,175,55,0.3)] ${
                    full ? "items-center" : "flex-col"
                  }`}
                >
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-gold/10 p-3 text-gold-dark transition group-hover:scale-110 group-hover:bg-gold group-hover:text-forest-950">
                    <Icon className="h-6 w-6" />
                  </span>
                  <div>
                    <h3 className="font-head text-lg font-bold text-forest-950">{item.title}</h3>
                    <p className="mt-2 text-sm leading-relaxed text-moss">{item.desc}</p>
                  </div>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
